/**
 * Splash screen utilities for Capacitor
 */

import { isNativePlatform } from './platform';

/**
 * Hide the splash screen (only on native platforms)
 * Call this after the app has finished initial loading
 */
export async function hideSplashScreen(): Promise<void> {
  if (!isNativePlatform()) {
    return;
  }

  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide({
      fadeOutDuration: 120,
    });
  } catch (error) {
    // Splash screen might already be hidden or not available
    console.warn('Failed to hide splash screen:', error);
  }
}

/**
 * Show the splash screen (only on native platforms)
 * Useful for showing during long operations
 */
export async function showSplashScreen(): Promise<void> {
  if (!isNativePlatform()) {
    return;
  }

  try {
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.show({
      autoHide: false,
    });
  } catch (error) {
    console.warn('Failed to show splash screen:', error);
  }
}
